import React, {useContext, useMemo, useState} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Avatar from "@mui/material/Avatar";
import { Link } from "react-router-dom";
import { userLogout } from "actions/user";
import context from "components/Shared/MSidebar/utility/context";
import WebConfig from "middlewares/WebConfig";
import { WindowContext } from "components/Shared/WindowProvider.tsx";

const DrawerFooter = ({
  user: {firstName, lastName, username},
  dispatch
}) => {
  const {open} = useContext(context);
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);
  
  const classname = useMemo(
    () => open ? "DrawerFooter-Name-Visisble" : "DrawerFooter-Name-Hidden",
    [open]
  );

  const handleClose = () => setAnchorEl(null);

  return (
    <div className={"DrawerFooter-Root"}>
      <Button
        id={"DrawerFooter"}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{ 
          textTransform: "none", 
          width: "100%", 
          justifyContent: "flex-start",
          minHeight: "unset",
          height: "100%",
          padding: 0,
          borderRadius: 0,
          backgroundColor: "var(--primary-color)",
          "&:hover, &.Mui-focusVisible": {
            backgroundColor: "var(--primary-color)",
          },
        }}
        disableRipple
      >
        <div className={"DrawerFooter-Contents"}>
          <Avatar className={"DrawerFooter-Avatar"} data-test="avatar">
            {(firstName || username).toUpperCase().charAt(0)}
          </Avatar>
          <div className={`DrawerFooter-Name ${classname}`}>
            {(firstName && lastName)
              ? `${firstName} ${lastName}`
              : username
            }
          </div>
        </div>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Link to="/profile" data-test="profile" style={{ textDecoration: "none", color: "inherit" }}>
          <MenuItem onClick={handleClose}>My Profile</MenuItem>
        </Link>
        <Link to="/change-password" data-test="change-password" style={{ textDecoration: "none", color: "inherit" }}>
          <MenuItem onClick={handleClose}>Change Password</MenuItem>
        </Link>
        {(WebConfig.environment === "testing" || WebConfig.environment === "development") && (
          <NewWindowMenuItem handleClose={handleClose} />
        )}
        <MenuItem onClick={() => { handleClose(); dispatch(userLogout()); }} data-test="logout">
          Logout
        </MenuItem>
      </Menu>
    </div>
  );
};

const NewWindowMenuItem = ({ handleClose }) => {
  const windowProvider = useContext(WindowContext);
  return (
    <MenuItem onClick={() => { handleClose(); windowProvider.openNewWindowWithSSO("", { openInNewTab: true }); }} data-test="new-window">
      New Window
    </MenuItem>
  );
};

NewWindowMenuItem.propTypes = {
  handleClose: PropTypes.func,
};

DrawerFooter.propTypes = {
  user: PropTypes.object,
  dispatch: PropTypes.func,
};

export default connect(
  state => ({
    user: state.user.profile,
  }),
  dispatch => ({
    dispatch,
  })
)(DrawerFooter);